import { render, staticRenderFns } from "./CollapsiblePanel.vue?vue&type=template&id=00cf7f3c&"
import script from "./CollapsiblePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsiblePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports